import { render, staticRenderFns } from "./default.vue?vue&type=template&id=77ed68f8&lang=pug&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./default.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteError: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/error.vue').default,SiteFlash: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/flash.vue').default,SiteAdminWarning: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/admin-warning.vue').default,SiteJumbotronLegacy: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/jumbotron/legacy.vue').default,WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/image.vue').default,SiteJumbotronGeneric: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/jumbotron/generic.vue').default,SiteJumbotronExpanded: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/jumbotron/expanded.vue').default,SiteJumbotronTacs: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/jumbotron/tacs.vue').default,SiteBreadcrumbs: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/breadcrumbs.vue').default,WidgetsQuoteRef: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/widgets/quote-ref.vue').default,SiteFooter: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/footer.vue').default,BaseModalsContainer: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/base/modals/container.vue').default,SiteMatomoTracker: require('/home/ubuntu/nuxt/bonkers/releases/20230927162708/components/site/matomo-tracker.vue').default})
